export default __webpack_public_path__ + "static/media/button.ef17e8d4.svg";